import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import * as ApplicationStandAloneMutations from "@Client/@Modules/application-standalone/store/application-standalone-mutations";
import * as ApplicationStandAloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import { useAddress } from "@Shared/@Composables/generic/useAddress";
import { useApplicationStandaloneStoreGetters, useApplicationStandaloneStoreMutations } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { computed } from "@vue/composition-api";
import { get } from "lodash";
export const useOtherPropertiesHelpers = (options = {
  otherPropertyIndex: 0,
  applicantIndex: 0
}) => {
  const {
    addNestedField,
    removeNestedField
  } = useBindApplication();
  const {
    RESET_OTHER_PROPERTIES_EXISTING_MORTGAGES
  } = useApplicationStandaloneStoreMutations([ApplicationStandAloneMutations.RESET_OTHER_PROPERTIES_EXISTING_MORTGAGES]);
  const {
    GET_CURRENT_APPLICATION
  } = useApplicationStandaloneStoreGetters([ApplicationStandAloneGetters.GET_CURRENT_APPLICATION]);
  const otherPropertyPath = computed(() => {
    const currentApplicantPath = options.applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${options.applicantIndex - 1}]`;
    return currentApplicantPath + "[other-properties]" + `[${options.otherPropertyIndex}]`;
  });
  const computedOtherPropertyHasExistingMortgages = computed(() => {
    var _ref;
    const currentApplication = GET_CURRENT_APPLICATION.value;
    const existingMortgages = get(currentApplication, otherPropertyPath.value + "[other-property-existing-mortgages]");
    return (_ref = existingMortgages && !!(existingMortgages != null && existingMortgages.length)) != null ? _ref : false;
  });
  const addEmptyOtherProperty = applicantIndex => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    addNestedField(currentApplicantPath + "[other-properties]");
  };
  const deleteOtherProperty = (applicantIndex, otherPropertyIndex) => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    removeNestedField(currentApplicantPath + "[other-properties]", otherPropertyIndex);
  };
  const applicantHasOtherProperties = otherProperties => otherProperties && !!otherProperties.length;
  const otherPropertySummarySubtitle = otherProperty => {
    var _otherProperty$proper;
    const address = otherProperty == null ? void 0 : (_otherProperty$proper = otherProperty["property-details"]) == null ? void 0 : _otherProperty$proper["address"];
    return useAddress(address).fullAddress.value;
  };
  const propertyHasExistingMortgages = otherProperty => {
    return otherProperty["other-property-existing-mortgages"] && !!otherProperty["other-property-existing-mortgages"].length;
  };
  const addExistingMortgage = (applicantIndex, otherPropertyIndex) => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    addNestedField(currentApplicantPath + "[other-properties]" + "[" + otherPropertyIndex + "]" + "[other-property-existing-mortgages]");
  };
  const deleteExistingMortgage = (applicantIndex, otherPropertyIndex, existingMortgageIndex) => {
    const currentApplicantPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    removeNestedField(currentApplicantPath + "[other-properties]" + "[" + otherPropertyIndex + "]" + "[other-property-existing-mortgages]", existingMortgageIndex);
  };
  const handleChangeIsThePropertyStillMortgaged = (value, applicantIndex, otherPropertyIndex) => {
    if (value) {
      addExistingMortgage(applicantIndex, otherPropertyIndex);
    } else {
      RESET_OTHER_PROPERTIES_EXISTING_MORTGAGES({
        otherPropertyIndex,
        applicantIndex
      });
    }
  };
  return {
    addEmptyOtherProperty,
    deleteOtherProperty,
    applicantHasOtherProperties,
    otherPropertySummarySubtitle,
    propertyHasExistingMortgages,
    handleChangeIsThePropertyStillMortgaged,
    computedOtherPropertyHasExistingMortgages,
    addExistingMortgage,
    deleteExistingMortgage
  };
};